import { useRef, useState, useEffect } from "react";
import { Box, useTheme, IconButton } from "@mui/material";
import { Flex } from "~/components/Flex";
import Text from "../../../../../../../components/ui-library/components/typography/Text";
import TextCaption from "~/components/ui-library/components/typography/TextCaption";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

interface Props {
  uid: string;
  mql: string;
  type: string;
}

export const CheckQueriesPropertyItem = ({ uid, mql, type }: Props) => {
  const theme = useTheme();
  const mqlRef = useRef<HTMLElement | null>(null);
  const [isEllipsisActive, setEllipsisActive] = useState(false);
  const [isShowMore, setShowMore] = useState(false);

  useEffect(() => {
    try {
      const handleResize = () => {
        const isEllipsisActive =
          Number(mqlRef.current?.scrollWidth) >
          Number(mqlRef.current?.offsetWidth);

        if (isShowMore) {
          return;
        }

        setEllipsisActive(isEllipsisActive);
      };

      handleResize();

      window.addEventListener("resize", handleResize);

      return () => {
        window.removeEventListener("resize", handleResize);
      };
    } catch (error) {}
  }, [isShowMore]);

  return (
    <Flex gap={3} pb={2}>
      <Flex sx={{ flexDirection: "column" }}>
        <Text bold sx={{ padding: "0 !important" }}>
          {uid}
        </Text>
        <TextCaption
          bold
          sx={{ color: "grey.500", textTransform: "uppercase" }}
        >
          {type}
        </TextCaption>
      </Flex>
      <Box
        ref={mqlRef}
        sx={{
          fontSize: 12,
          padding: "8px 16px",
          overflow: "hidden",
          whiteSpace: isShowMore ? "normal" : "nowrap",
          backgroundColor: "background.light",
          WebkitBoxOrient: "vertical",
          display: "-webkit-box",
          position: "relative",
          paddingTop: "6px",
          paddingBottom: "4px",
          width: isShowMore ? "100%" : "fit-content",
          borderRadius: 1,
        }}
      >
        <Box
          sx={{
            width: isShowMore ? "96%" : "93%",
            fontSize: "16px",
            paddingTop: "3px",
          }}
        >
          {mql}
        </Box>

        {isEllipsisActive && (
          <Box
            sx={{
              backgroundColor: "background.light",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              position: "absolute",
              top: "10px",
              right: 0,
            }}
          >
            <IconButton
              sx={{
                p: 0,
                color: theme.palette.secondary.light,
                width: "50px",
                "&:hover": {
                  backgroundColor: "inherit",
                },
              }}
              size="small"
              onClick={() => {
                setShowMore((v) => !v);
              }}
            >
              <ExpandMoreIcon
                sx={{
                  transform: isShowMore ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.2s",
                  width: "20px",
                  height: "20px",
                }}
              />
            </IconButton>
          </Box>
        )}
      </Box>
    </Flex>
  );
};
